import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";

import history from './modules/history'
import favorites from './modules/favorites'
import genres from './modules/genres'
import geolocation from './modules/geolocation'
import googleMap from './modules/googleMap'
import loading from './modules/loading'
import map from './modules/map'
import places from './modules/places'
import stations from './modules/stations'
import locations from './modules/locations'
import points from './modules/points'
import translation from './modules/translation'
import user from './modules/user'
import drawer from './modules/drawer'
import busLocation from './modules/busLocation'
import courses from './modules/courses'
import notice from './modules/notice'

Vue.use(Vuex);

const dataState = createPersistedState({
  paths: [
    'favorites',
    'history',
    'map',
    'locations',
    'user',
    'notice'
  ],
  // NOTE: vuex-persistedstateで復元するときに日付を文字列からmomentに変換
  subscriber(store) {
    return function(handler) {
      return store.subscribe(handler)
    }
  }
})

const actions = {
  init ({ dispatch }) {
    dispatch('genres/reset', {}, { root: true })    
    dispatch('places/reset', {}, { root: true })
    dispatch('stations/reset', {}, { root: true })
    dispatch('points/reset', {}, { root: true })
    dispatch('translation/reset', {}, { root: true })
    dispatch('courses/reset', {}, { root: true })
  },
  resetAll ({ dispatch }) {
    dispatch('favorites/reset', {}, { root: true })
    dispatch('geolocation/reset', {}, { root: true })
    dispatch('googleMap/reset', {}, { root: true })
    dispatch('history/reset', {}, { root: true })
    dispatch('map/reset', {}, { root: true })
    dispatch('locations/reset', {}, { root: true })
    dispatch('user/reset', {}, { root: true })
    dispatch('notice/reset', {}, { root: true })
  }
}

const store = new Vuex.Store({
  actions,
  plugins: [dataState],
  modules: {
    favorites,
    genres,
    geolocation,
    googleMap,
    history,
    loading,
    map,
    places,
    stations,
    locations,
    points,
    translation,
    user,
    drawer,
    busLocation,
    courses,
    notice
  }
})

export default store
